import React, { Fragment } from 'react';
import {Col} from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';
import Button from '../button/Button';
import FilterTypeEnum from './FilterTypeEnum';

class Filter extends AbstractComponent { 
    onChange(index, e) {
        this.props.onFilterChange(index, e);
    }

    onChangeSelect(index, e) {
        this.props.onFilterChangeSelect(index, e);
    }

    exibeCampo(item, index) {
        return (
            FilterTypeEnum.get(item.type.enumName).component(this, item, index)
        );         
    }

    showComponent() {
        if(this.props.filter.length === 0)
            return ;

        return (
            <Col 
                md={12} 
                xs={12}
                sm={12} 
                lg={12}                
            >                

                {
                    this.props.filter.map((item, i) => {                        
                        return (
                            this.exibeCampo(item, i)
                        )
                    })
                } 

                <div 
                    className="col-md-2
                               col-sm-2
                               col-lg-2
                               col-xs-12"
                    style={{
                        marginTop: '25px'
                    }}
                >
                    {
                        this.props.showButtonSearch &&                                            
                        <Button 
                            className={"btn btn-primary " + (this.props.preload ? "is" : "not") + "-loading text-center"}
                            style={{marginRight: '10px'}}
                            type="button"                                                 
                            onClick={() => {this.props.onFilterButtonClick()}}
                        >
                            <div className="btn-spinner">
                                <div className="double-bounce1">
                                </div>
                                
                                <div className="double-bounce2">
                                </div>
                            </div>

                            <i className="fa fa-search"/>
                        </Button>                        
                    }   

                    <Button 
                        className="btn btn-danger not-loading text-center"
                        type="button"                                                 
                        onClick={() => {this.props.onFilterClearClick()}}
                    >
                        <i className="fa fa-eraser" />
                    </Button>
                </div>
            </Col>    
        )
    }

    componentDidMount() {
        this.foco(this.props.defaultFoco);
    }

    render() {        
        return (
            <Fragment>
                { this.showComponent() }
            </Fragment>
        )
    }
}

Filter.defaultProps = {
    defaultFoco: 'id',
    showButtonSearch: true
}

export default Filter;